import { authorizeClient } from '@/api/http-client';
import {
    CustomFieldsAdminApiFactory,
    CustomFieldBaseRequest,
    CustomFieldMapItem,
} from '@eloomi/eloomi-users-persona-client/1.0';
import { DataRequestOptions } from '@/common/components/table';
import { buildFilter } from '@/common/services';

const client = authorizeClient(CustomFieldsAdminApiFactory);
const customFieldsAdminClient = authorizeClient(CustomFieldsAdminApiFactory);

export function getCustomFields(options: DataRequestOptions) {
    const filterStr = buildFilter('name', options.searchQuery);

    return client.getCustomFields(filterStr, undefined, options.page, options.pageSize).then(({ data }) => data);
}

export function getCustomFieldsLite() {
    return client.getCustomFieldsLite().then(({ data }) => data);
}

export function getCustomFieldById(id: number) {
    return client.getCustomFieldById(id);
}

export function createCustomField(customField: CustomFieldBaseRequest) {
    return client.createCustomField(customField);
}

export function updateCustomField(id: number, customField: CustomFieldBaseRequest) {
    return client.updateCustomField(id, customField);
}

export function deleteCustomField(id: number) {
    return client.deleteCustomField(id);
}

export async function updateCustomUsersFields(fields?: CustomFieldMapItem[]) {
    return customFieldsAdminClient.mapCustomFields(fields);
}
